export default __webpack_public_path__ + "static/media/orders.fb490a0c.svg";